/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  activateOrganization: {
    id: 'organization.organization-overview.activate-organization',
    defaultMessage: 'Activate organization',
  },
  deactivateOrganization: {
    id: 'organization.organization-overview.deactivate-organization',
    defaultMessage: 'Deactivate organization',
  },
  cancel: {
    id: `organization.organization-overview.convert-organization-button.cancel`,
    defaultMessage: `Cancel`,
  },
  convertOrganizationReason: {
    id: `organization.organization-overview.convert-organization-button.reason-label`,
    defaultMessage: `Reason`,
  },
  convertOrganizationReasonHelp: {
    id: `organization.organization-overview.convert-organization-button.reason-label-help`,
    defaultMessage: `Optional description for the change. Example: User paid bill and requested this change.`,
  },
  convertOrganizationIssue: {
    id: `organization.organization-overview.convert-organization-button.issue-label`,
    defaultMessage: `Issue`,
  },
  convertOrganizationIssueHelp: {
    id: `organization.organization-overview.convert-organization-button.issue-label-help`,
    defaultMessage: `Optional SDH Github issue link.`,
  },
})
